import React from 'react';
import { Form } from 'react-final-form';
import { Outlet } from 'react-router-dom';
import { UserProfile } from '@teetsh/app/src/types/user';
import AutoSubmitForm from '@teetsh/app/src/components/AutoSave';
import useUpdateUser from '@teetsh/app/src/queries/user/useUpdateUser';
import { useUser } from '@teetsh/app/src/containers/App/context/useUser';

export function UserSettingsComponent() {
  const user = useUser();
  const updateUser = useUpdateUser();
  return (
    <Form<UserProfile>
      initialValues={user}
      onSubmit={async values => {
        await updateUser(values);
        return {};
      }}
    >
      {({ handleSubmit }) => (
        <form onSubmit={handleSubmit}>
          <AutoSubmitForm />
          <Outlet />
        </form>
      )}
    </Form>
  );
}
